import React, { useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

export default function AdminChangePassword() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) return toast.error("La nueva contraseña debe tener al menos 8 caracteres");
    if (next !== confirm) return toast.error("Las contraseñas no coinciden");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada");
      setCurrent(""); setNext(""); setConfirm("");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-600 to-teal-600 flex items-center justify-center text-white">
          <KeyRound size={20} />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Cambiar contraseña</h1>
          <p className="text-sm text-slate-500">Actualiza tu contraseña de administrador</p>
        </div>
      </div>

      <form onSubmit={submit} className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm space-y-4">
        <Field label="Contraseña actual" value={current} onChange={(e) => setCurrent(e.target.value)} required />
        <Field label="Nueva contraseña" value={next} onChange={(e) => setNext(e.target.value)} hint="Mínimo 8 caracteres" required />
        <Field label="Confirmar nueva contraseña" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
        <button type="submit" disabled={loading} className="w-full bg-gradient-to-r from-cyan-600 to-teal-600 text-white font-semibold py-3 rounded-xl disabled:opacity-60 flex items-center justify-center gap-2">
          {loading ? <><Loader2 className="animate-spin" size={16} /> Actualizando...</> : "Cambiar contraseña"}
        </button>
      </form>
    </div>
  );
}

function Field({ label, hint, ...props }) {
  return (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1.5">{label}</label>
      <input
        type="password"
        {...props}
        className="w-full px-4 py-2.5 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-cyan-500"
      />
      {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
    </div>
  );
}
